import { customDispatch } from "@affinity/Store/ServiceBase";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { BillToModel, ShipToCollectionModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";

// External parameters
interface LoadAddressesParameters {
    billTo: BillToModel,
}

// Internal parameters
interface Props {
    shipTos: ShipToCollectionModel,
}

type HandlerType = Handler<LoadAddressesParameters, Props>;

export const LoadAddresses: HandlerType = ({ dispatch, parameter: { } }) => {
    // call shared code
}

export const UpdateState: HandlerType = ({ dispatch, parameter: { } }) => {
    //

    // TIE TO MY ACCOUNT FOR SHARED USE BETWEEN FORM LOGIC
}

export const Tracking: HandlerType = ({ dispatch, parameter: { } }) => {
    //
}

export const chain = [
    LoadAddresses,
    UpdateState,
    Tracking,
];

const loadAddresses = createHandlerChainRunner(chain, "LoadAddresses");
export default loadAddresses;